import { DataSource } from '@angular/cdk/collections';
import { MdPaginator, MdSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { IesHttpClient } from './ies-http-client.service';


/**
* Data source to provide what data should be rendered in the table. The observable provided
* in connect should emit exactly the data that should be rendered by the table. If the data is
* altered, the observable should emit that new set of data on the stream. In our case here,
* we return a stream that contains only one set of data that doesn't change.
*/

export class TableDataSource extends DataSource<any> {
  _httpClient: IesHttpClient;
  curPage = 2; //required to change pagination dynamically
  initialPageSize = 5; //required to pass on pagination grid
  pageSizeOptions = [5, 10, 25, 50, 100];
  constructor(private subject: BehaviorSubject<any[]>, private _paginator: MdPaginator, private _sort: MdSort,
    _httpClient?: IesHttpClient) {
    super();
    this._httpClient = _httpClient;
  }
  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<any[]> {
    let displayDataChanges;

    // If pagination has been defined
    if (this._paginator) {
      displayDataChanges = [
        this.subject,
        this._paginator.page,
        this._sort.mdSortChange
      ];
    } else {
      // If pagination is not defined then don't paas pagination object
      displayDataChanges = [
        this.subject,
        this._sort.mdSortChange
      ];
    }

    return Observable.merge(...displayDataChanges).map(() => {
      return this.getSortedData();
    });
  }

  /** Returns a sorted copy of the database data with Pagination. */
  getSortedData(): any[] {
    let filterData;
    filterData = this.subject.getValue();
    if (this._sort) {
      if (!this._sort.active || this._sort.direction == '') {
        return this.setPagination(filterData);
      }

      return this.setPagination(
        filterData.sort((a, b) => {
          let propertyA: number | string = '';
          let propertyB: number | string = '';
          [propertyA, propertyB] = [a[this._sort.active] ? a[this._sort.active].toString().toLowerCase().trim() : '',
          b[this._sort.active] ? b[this._sort.active].toString().toLowerCase().trim() : ''];

          let valueA = isNaN(+propertyA) ? propertyA : +propertyA;
          let valueB = isNaN(+propertyB) ? propertyB : +propertyB;

          return (valueA < valueB ? -1 : 1) * (this._sort.direction == 'asc' ? 1 : -1);
        })
      );
    } else {
      return this.setPagination(filterData);
    }

  }

  /*
   * In this method we do pagination for grid.
   * Based on PageIndex and pageSize we filter records from all data and set it into filter data array
   * If there are no records in pagaination then hit request to get more records
   * After pagination, sort data and return finalData.
  */
  setPagination(data: any): any[] {
    let filterData = [];
    if (this._paginator) {
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      // Filter record based on startIndex and page Size
      if (data && data.length > 0) {
        for (let i = startIndex; i < this._paginator.pageSize + startIndex; i++) {
          if (data[i]) {
            filterData.push(data[i]);
          }
        }
      }
    } else {
      filterData = data;
    }
    return filterData;
  }
  disconnect(): void {

  }

  /*for dynamic page updation
   url - url of the api to call
   event - page event
   me - this scope of the component
   urlSearchParams - extra seach parameter when needed(optional)*/
  onPaginateChange(url, event, me, urlSearchParams?) {
    try {
      let totalIndex = me.dataSubject.getValue().length / event.pageSize;
      totalIndex = (Math.ceil(totalIndex));
      if (event.pageIndex == totalIndex - 1) {
        let urlParams = this.curPage + "/?pageSize=100";
        if (urlSearchParams) {
          urlParams = this.curPage + urlSearchParams;
        }
        return this._httpClient.get(url, urlParams)
          .subscribe((response: any) => {
            if (response.response.results.length > 0) {
              let existData = me.dataSubject.getValue(); // get exist data
              let data = response.response.results;
              // If data exist then concat new records in exists data collection.
              let result = (existData.length != 0) ? existData.concat(data) : data;
              me.dataSubject.next(result);
              me.paginationInfo = response.response.paginationInfo; // update paginaton info
              this.curPage++;
            }
          });
      }
    } catch (e) {
      console.log("Pagination error", e);
    }
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/md-table.ts